import { Injectable } from '@angular/core';

@Injectable()
export class UserprofileService {

    constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/_services/profile/userprofile.service.ts